import { decodeHtml } from '@nx/decode-html'

const currencyConversions = {
  '£': 'GBP',
  US$: 'USD',
  '€': 'EUR',
  AU$: 'AUD',
  CA$: 'CAD',
  HK$: 'HKD',
  TW$: 'TWD',
}

function isCurrencyKey(
  currency: string
): currency is keyof typeof currencyConversions {
  return currency in currencyConversions
}

function isCurrencyValue(currency: string): boolean {
  return Object.values(currencyConversions).includes(currency)
}

export function a3CurrencyConverter(currency: string) {
  const decodedCurrency = decodeHtml(currency)
  if (isCurrencyKey(decodedCurrency)) {
    return currencyConversions[decodedCurrency]
  }
  return decodedCurrency
}

export function inverseA3CurrencyConverter(currency: string) {
  if (isCurrencyValue(currency)) {
    return Object.keys(currencyConversions)[
      Object.values(currencyConversions).indexOf(currency)
    ]
  }

  return currency
}
